import { NgModule } from '@angular/core';

import { SharedModule } from '../../../../../shared';

import { PessoaTermoLGPDStatusPipe } from './pessoa-termo-lgpd-status.pipe';
import { PessoaTermoLGPDStatusBadgePipe } from './pessoa-termo-lgpd-status-badge.pipe';


@NgModule({
    imports: [
        SharedModule
    ],
    declarations: [
        PessoaTermoLGPDStatusPipe,
        PessoaTermoLGPDStatusBadgePipe
    ],
    exports: [
        PessoaTermoLGPDStatusPipe,
        PessoaTermoLGPDStatusBadgePipe
    ],
    providers: [
        PessoaTermoLGPDStatusPipe,
        PessoaTermoLGPDStatusBadgePipe
    ]
})
export class PessoaTermoLGPDStatusPipeModule { }
